import { render, staticRenderFns } from "./PreOrderDetailSuperAdmin.vue?vue&type=template&id=0ece6839&scoped=true"
import script from "./PreOrderDetailSuperAdmin.vue?vue&type=script&lang=js"
export * from "./PreOrderDetailSuperAdmin.vue?vue&type=script&lang=js"
import style0 from "./PreOrderDetailSuperAdmin.vue?vue&type=style&index=0&id=0ece6839&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece6839",
  null
  
)

export default component.exports